import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { CiamService } from './ciam.service';
import { SessionNoticeService } from './session-notice.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private readonly ciamService: CiamService,
    private readonly router: Router,
    private readonly sessionNotice: SessionNoticeService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.ciamService.ensureAuthenticated().pipe(
      map(isAuthenticated => isAuthenticated ? true : this.loginUrlTree(state.url)),
      // Seuls les rejets définitifs (400/401/403) sont convertis en `false` par `CiamService` ;
      // une panne du BFF ou du réseau remonte ici. Sans ce rattrapage, elle échappe au routeur,
      // qui l'affiche en « [404] Ressource introuvable » — un message faux, et à trois niveaux
      // de la cause réelle.
      catchError(error => {
        console.error('Échec de la vérification de la session CIAM.', error);
        this.sessionNotice.notifyUnavailableService(state.url);
        return of(this.loginUrlTree(state.url));
      }),
    );
  }

  /**
   * La page de connexion est la seule destination sûre : on n'atteint ce point que sans jeton
   * local exploitable, donc sans session du point de vue de l'application.
   */
  private loginUrlTree(returnUrl: string): UrlTree {
    return this.router.createUrlTree(['/connexion'], { queryParams: { returnUrl } });
  }
}
